import memoize from 'lodash.memoize';
import normalizeLanguageProperty from './normalizeLanguageProperty';

var normalizeMetadataProperty = memoize(function (metadata, defaultLanguage) {
  return Array.isArray(metadata) ? metadata.map(function (metadataItem) {
    return metadataItem.value ? {
      label: normalizeLanguageProperty(metadataItem.label, defaultLanguage),
      value: normalizeLanguageProperty(metadataItem.value, defaultLanguage)
    } : null;
  }).filter(function (e) {
    return e;
  }) : [];
});

export default normalizeMetadataProperty;